import { ModelItem, ModelOption } from './model-item';
import { ValueOptions } from './model-item-options';
import { IModelDataPathPart } from './util/model-data';

export class FieldType {
  static STRING = 'string';
  static NUMBER = 'number';
  static BOOLEAN = 'boolean';
  static DATE = 'date';
  static TIME = 'time';
  static DATE_TIME = 'datetime';
  static IBAN = 'iban';
  static BIC = 'bic';
  static MULTILINE = 'multiline';
}

export interface IModelContext {
  value?: any;
  dataStack?: any[];
  parts?: IModelDataPathPart[];
  customData?: any;
  loggingStreamId?: string;
}

export const jaOption: ModelOption = { name: 'Ja', value: 1 };
export const neinOption: ModelOption = { name: 'Nein', value: 2 };

export const jaNeinOptions: ValueOptions = new ValueOptions([jaOption, neinOption]);

export type DefaultValueHandler = (modelItem: ModelItem, modelContext: IModelContext) => any;
